<template>
<div role="group" class="b-form-group form-group">
  <table class="table table-foursight table-striped table-hover table-sm">
    <tbody>
      <template v-for="item in scheduleSummary">
        <thead>
          <th colspan="2" class="no-border">
            {{item.name}} {{$t('SCHEDULE')}}
          </th>
        </thead>
        <tr>
          <td>{{$t('DATE')}}</td>
          <td>{{$t('HOURS')}}</td>
        </tr>
        <template v-for="child in item.children">
          <tr>
            <td>
              {{ moment(child.date).format('ddd-MMM/DD/YY')}}
            </td>
            <td>
              {{ moment(moment.utc(child.startTime).toDate()).local().format('hh:mm A')}} to {{moment(moment.utc(child.endTime).toDate()).local().format('hh:mm A')}}
            </td>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</div>
</template>

<script>
export default
{
  name: 'UserScheduleSummaryForm',
  props: ['scheduleSummary'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
